import { connect } from "react-redux";

var ReactionFeedback = require("components/support/ReactionFeedback");
var ScoringData = require("components/writing/evaluations/ScoringData");
var RubricItemOverride = require("components/writing/evaluations/RubricItemOverride")
var TextAreaMarkups = require("components/writing/evaluations/TextAreaMarkups");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");

var Spinner = require("components/utility/Spinner");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");

var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");
require("writing/answers/answer_scoring_details.scss");

@connect(
	(state, props) => ({
		evaluation: WritingSelectors.evaluation({ state, id: props.answer.evaluation })
	}),
	(dispatch, props) => ({
	})
)
class AnswerScoringDetails extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			markupKey: null,
			activeLeaf: null
		};
	}

	isEssay() {
		return this.props.answer.question_type == 'essay-question'
	}

	getEssayText() {
		if (!this.props.answer || !this.props.answer.parts || !this.props.answer.parts[0]) {
			return ""
		}

		return this.props.answer.parts[0].text
	}

	onModeChange(controlMode) {
		if (this.props.onModeChange) {
			this.props.onModeChange(controlMode)
		}
	}

	answerDetails() {
		if (this.props.answer && this.props.evaluation) {
			return this.props.evaluation.autograder_data;
		}
	}

	selectMarkup(markupKey) {
		var leaves = this.leaves();
		this.setState({ markupKey })

		if (leaves && leaves[markupKey]) {
			this.setState({ activeLeaf: leaves[markupKey] })
		}
	}

	currentMarkupKey() {
		if (this.state.markupKey) {
			return this.state.markupKey;
		}

		var leaves = this.leaves();
		if (leaves) {
			return _.keys(leaves)[0];
		}
	}

	leaves() {
		var answerDetails = this.answerDetails();
		if (this.isEssay()){
			var standard = !_.isEmpty(answerDetails.skillset) ? answerDetails.skillset : null;
			switch (answerDetails.version) {
				case 'v2.0':
					return AutograderDisplayConfig.getEssayRubricLeavesv2(answerDetails.rubric, standard);
				default:
					return AutograderDisplayConfig.getEssayRubricLeavesv1(answerDetails.rubric);
			}
		} else if (answerDetails){
			return AutograderDisplayConfig.getRubricLeaves(answerDetails.polarizing, false);
		}
	}

	handleSpecialTags(tag, leaves, markupKey) {
		if (tag.key.includes("COSA_BERT_SCORE")) {
			var cosePresent = _.any(leaves[markupKey].tags, (tag) => { return tag.key.includes("COSE_BERT_SCORE") })
			if (cosePresent) {
				tag.key = "EVIDENCE_SUPPORTED_CLAIM"
				tag.key = tag.key
			}
		}

		return tag
	}

	activeTagging() {
		var leaves = this.leaves();
		var markupKey = this.currentMarkupKey();

		if (leaves && leaves[markupKey]) {
			var activeTags = {}
			_.each(leaves[markupKey].tags, (tag) => {
				tag = this.handleSpecialTags(tag, leaves, markupKey)
				if (activeTags[tag.key] == undefined) {
					activeTags[tag.key] = []
				}
				activeTags[tag.key].push(tag)
			})
			
			if (!this.isEssay()) {
				_.each(activeTags, (tags, key) => {
					if (!AutograderDisplayConfig.isDisplayTag(key)) {
						delete activeTags[key];
					}
				});
			}

			_.each(activeTags, (tags, key) => {
				if (AutograderDisplayConfig.shouldGroupTagSpans(key)) {
					_.each(tags, (tag, t) => {
						activeTags[key][t].spans = AutograderDisplayConfig.groupTagSpans(tag)
					})
				}
			})

			return activeTags;
		} else {
			return {};
		}
	}

	renderScoringData() {
		var answerDetails = this.answerDetails();
		// need to extract essay data in format that scoring data expects
		if (answerDetails.question_type == 'essay-question'){
			var filtering = answerDetails.errors
			var warning = answerDetails.warnings
			var evaluating = answerDetails.overall_score
		} else {
			var filtering = answerDetails.filtering
			var warning = answerDetails.warning
			var evaluating = answerDetails.evaluating
		}
	
		var activeTagging = this.activeTagging();
		var tagColors = pickTagColors(activeTagging);

		if (this.props.editMode) {
			var scoringData = (
				<RubricItemOverride leaves={this.leaves()} evaluation={this.props.evaluation} />
			)
		} else {
			var scoringData = (
				<ScoringData onModeChange={this.onModeChange} markupKey={this.currentMarkupKey()}
					tagging={activeTagging} leaves={this.leaves()} tagColors={tagColors}
					selectMarkup={this.selectMarkup} filtering={filtering} warning={warning} evaluating={evaluating} />
			)
		}

		if (this.isEssay()){
			if (_.isEmpty(this.state.activeLeaf)) {
				var leaves = this.leaves()
				var firstLeafKey = _.keys(leaves)[0];
				var activeLeaf = leaves[firstLeafKey]
			} else {
				var activeLeaf = this.state.activeLeaf
			}

			return (
				
				<div>
					<div className='essayText'>
						<TextAreaMarkups text={this.getEssayText()} activeLeaf={activeLeaf}
							tagging={activeTagging} tagColors={tagColors} />
					</div>
					
					{scoringData}
				</div>

			)
		} else {
			return (
				<div>
					<div className="answerText">
						<TextAreaMarkups text={answerDetails.corrected_answer}
							tagging={activeTagging} tagColors={tagColors} />
					</div>
					{scoringData}
				</div>
			)
		}


	}

	render() {
		var originalAnswer = this.props.answer;
		var answerDetails = this.answerDetails();
		if (!originalAnswer) {
			var displayContent = (
				<Spinner placeholder />
			);

		} else if (!answerDetails) {
			if (originalAnswer.body != undefined) {
				var answerText = originalAnswer.body
			} else {
				var answerText = <MultiPartAnswerDisplay parts={ originalAnswer.parts } breakSections />
			}
			if ("evaluation_details" in this.props.answer) {
				var status = (
					<p className="text-center">
						Scoring details are unvailable for this answer.
					</p>
				)
			} else {
				var status = <Spinner placeholder />
			}
			var displayContent = (
				<div>
					<p className="answerText">
						{ answerText }
					</p>
					{ status }
				</div>
			)

		} else if (!answerDetails.corrected_answer && answerDetails.question_type != "essay-question") {
			var displayContent = (
				<div>
					<p className="answerText">
						{ originalAnswer.body }
					</p>
					<i>Our scoring algorithm has changed since this answer was scored. Please contact
					{ " " }<a href="mailto:support@whooosreading.org">support@whooosreading.org</a>
					{ " " }if you would like us to re-score this answer.</i>
				</div>
			)

		} else {
			var displayContent = this.renderScoringData(answerDetails)
		}

		return (
			<div className="answerScoringDetails">
				{ displayContent }
			</div>
		);
	}
}

function pickTagColors(tagging) {
	var tagToColors = {};
	_.each(_.sortBy(_.keys(tagging)), (key, index) => {
		var hasSpans = _.any(tagging[key], (tag) => "spans" in tag);
		if (hasSpans) {
			// Check if any key from TAG_SPECIFIC_COLORS is a subset of the current key
			var specificKey = _.findKey(TAG_SPECIFIC_COLORS, (_, tagKey) => key.includes(tagKey));
			if (specificKey) {
				tagToColors[key] = TAG_SPECIFIC_COLORS[specificKey];
			} else {
				tagToColors[key] = AUTOGRADER_COLOR_LIST[index % AUTOGRADER_COLOR_LIST.length];
			}
		}
	})

	return tagToColors;
}

var AUTOGRADER_COLOR_LIST = ["#96dafe", "#a0e881", "#ffcbb3", "#cfadec", "#f2de7f",
	"#c8ecff", "#c0f2aa", "#faaf88", "#fff864"]

var TAG_SPECIFIC_COLORS = {
	"COSO_F_BERT_SCORE": AUTOGRADER_COLOR_LIST[0],
	"COSO_RO_BERT_SCORE": AUTOGRADER_COLOR_LIST[1],
	"COSA_BERT_SCORE": AUTOGRADER_COLOR_LIST[0],
	"COSE_BERT_SCORE": AUTOGRADER_COLOR_LIST[0],
	"EVIDENCE_SUPPORTED_CLAIM": AUTOGRADER_COLOR_LIST[1],
}

AnswerScoringDetails.WrappedComponent.propTypes = StrictPropTypes({


	// Inserted by @connect
	evaluation: PropTypes.object,
	
	answer: PropTypes.object,
	editMode: PropTypes.bool,
	onModeChange: PropTypes.func,

});

module.exports = AnswerScoringDetails;


// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerScoringDetails.js